import { isNil, omitBy } from 'lodash'
import LogRocket from 'logrocket'

interface Traits {
  email?: string | null
  name?: string | null
  organizationId?: string | null
  organizationName?: string | null
}

/**
 * Identifies a user in LogRocket, attaching any traits with non-null values
 */
export function identifyUser(userId: string, traits: Traits = {}) {
  LogRocket.identify(userId, omitBy(traits, isNil) as Record<string, string>)
}
